import { h, defineComponent, VNode } from 'vue';
// @ts-ignore
import { BLoading } from 'buefy/dist/esm/loading';

export interface LoadingProps {
  active: boolean;
}

export const Loading = defineComponent<LoadingProps>({
  props: ['active'],
  setup(props) {
    return function render(): VNode {
      return h(BLoading, { props: { active: props.active, isFullPage: false } }, []);
    };
  },
});
